import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useSiteFeatureFlags = () => {
  const [flags, setFlags] = useState({
    require_account_for_checkout: false,
    require_email_verification_for_registration: true,
  });

  useEffect(() => {
    let active = true;

    const fetchFlags = async () => {
      try {
        const response = await fetch(`${API_URL}/api/settings/site`);
        if (!response.ok) return;

        const data = await response.json();
        if (!active) return;

        setFlags({
          require_account_for_checkout: Boolean(data.require_account_for_checkout),
          require_email_verification_for_registration:
            data.require_email_verification_for_registration !== false,
        });
      } catch (error) {
        // Keep safe defaults
      }
    };

    fetchFlags();

    return () => {
      active = false;
    };
  }, []);

  return flags;
};
